export type Sensitivity = 'standard' | 'political' | 'sensitive';
export type SourceRelation = 'first_report' | 'follow_up' | 'update' | 'correction' | 'rebuttal' | 'withdrawal';
export type TimePrecision = 'exact' | 'date_only' | 'unknown';
export type RecheckOutcome = 'new_source' | 'no_change' | 'source_unavailable' | 'check_later';

export interface VerificationQueueItem {
  id: string;
  caseId: string;
  url: string;
  note: string;
  createdAt: string;
}

export interface RecheckEntry {
  id: string;
  caseId: string;
  outcome: RecheckOutcome;
  note: string;
  checkedAt: string;
}

export interface SourceReceipt {
  id: string;
  url: string;
  publisher: string;
  publishedAt?: string;
  modifiedAt?: string;
  officialCorrectionUrl?: string;
  archiveUrl?: string;
  editedAt?: string;
  checkedAt: string;
  relation: SourceRelation;
  relatedReceiptId?: string;
  timePrecision: TimePrecision;
  createdAt: string;
  revision: number;
}

export interface UserClaim {
  id: string;
  text: string;
  sourceReceiptIds: string[];
  editedAt?: string;
  createdAt: string;
  revision: number;
}

export interface HistoryEntry {
  id: string;
  caseId: string;
  type: 'case_created' | 'receipt_added' | 'claim_added' | 'reminder_changed' | 'case_archived' | 'case_restored' | 'verification_queued' | 'verification_removed' | 'recheck_recorded' | 'receipt_edited' | 'receipt_removed' | 'receipt_moved' | 'claim_edited' | 'claim_removed' | 'case_renamed' | 'case_deleted' | 'change_undone' | 'archive_added' | 'deadline_set' | 'bulk_imported' | 'case_exported';
  before?: Record<string, string>;
  after?: Record<string,string>;
  exportKind?: 'html' | 'csv' | 'claim_packet' | 'text';
  at: string;
  summary: string;
  revision: number;
}

export interface CaseNotebook {
  id: string;
  label: string;
  sensitivity: Sensitivity;
  purpose?: 'claim' | 'scrap' | 'watch';
  deadline?: { knownOn: string; reportedOn: string };
  createdAt: string;
  updatedAt: string;
  archivedAt?: string;
  reminderAt?: string;
  receipts: SourceReceipt[];
  claims: UserClaim[];
  revision: number;
}

export interface VaultData {
  schemaVersion: 1;
  createdAt: string;
  updatedAt: string;
  cases: CaseNotebook[];
  history: HistoryEntry[];
  verificationQueue: VerificationQueueItem[];
  rechecks: RecheckEntry[];
}

export function emptyVault(now = new Date().toISOString()): VaultData {
  return { schemaVersion: 1, createdAt: now, updatedAt: now, cases: [], history: [], verificationQueue: [], rechecks: [] };
}
